import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';


const styles = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems:'center',
        marginTop: 18,
        marginBottom: 18,
    },
    left: {
        display:'flex',
        alignContent:'center',
        justifyContent:'center',
        width:48,
        marginRight: 16
    },
    children: {
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
    },
});


const SubscriptionListItem = ({ left, classes, children }) => (
    <div className={classes.root} >
        <div className={classes.left} >
            {left} 
        </div>
        <div className={classes.children}>
            {children}
        </div>
    </div>
  );
  
  SubscriptionListItem.propTypes = {
    children: PropTypes.element.isRequired,
    left: PropTypes.element.isRequired,
    classes: PropTypes.object.isRequired,
  }

  export default withStyles(styles)(SubscriptionListItem);


// WEBPACK FOOTER //
// ./src/components/subscriptions/SubscriptionListItem.js